import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import HeroBackground from "@/components/HeroBackground";
import FinalCTA from "@/components/FinalCTA";
import SectionHeading from "@/components/SectionHeading";
import { useT } from "@/i18n";

export default function Industries() {
  const t = useT();
  return (
    <div>
      <section className="relative overflow-hidden">
        <HeroBackground />
        <div className="relative nx-container pt-16 md:pt-24 pb-20 md:pb-28">
          <div className="nx-mono text-xs uppercase tracking-[0.32em] text-[#38D8FF] mb-5 nx-fade-in">
            / {t.industriesPage.eyebrow}
          </div>
          <h1 className="nx-heading text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight max-w-4xl tracking-tight nx-fade-in">
            <span className="nx-gradient-text">{t.industriesPage.title1}</span> {t.industriesPage.title2}
          </h1>
          <p className="mt-6 max-w-2xl text-lg text-white/75 leading-relaxed nx-fade-in">
            {t.industriesPage.lede}
          </p>
        </div>
      </section>

      <section className="nx-container pb-24 md:pb-32">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {t.industries.map((ind) => (
            <div key={ind.slug} className="nx-card rounded-2xl p-7 hover:-translate-y-1 transition-transform">
              <div className="text-sm text-[#38D8FF] nx-mono mb-3">/ {ind.slug}</div>
              <h3 className="nx-heading text-lg font-semibold">{ind.title}</h3>
              <p className="mt-3 text-sm text-white/65 leading-relaxed">{ind.desc}</p>
              <Link
                to="/contact"
                className="mt-5 inline-flex items-center gap-1 text-xs text-[#38D8FF] hover:text-white transition"
              >
                {t.industriesPage.talkLink} <ArrowRight className="w-3.5 h-3.5" />
              </Link>
            </div>
          ))}
        </div>
      </section>

      <FinalCTA />
    </div>
  );
}
